import { ReactNode } from "react";
import { useAuth } from "../hooks/useAuth";
import LoadingSpinner from "./LoadingSpinner";
import { isTeacher, isStudent } from "@/utils/role-utils";

interface RoleBasedViewProps {
  studentView: ReactNode;
  teacherView: ReactNode;
  loadingView?: ReactNode;
  fallbackView?: ReactNode;
}

const RoleBasedView = ({
  studentView,
  teacherView,
  loadingView = <LoadingSpinner message="Loading..." />,
  fallbackView = <div>Access denied</div>,
}: RoleBasedViewProps) => {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return <>{loadingView}</>;
  }

  if (!user) {
    return <>{fallbackView}</>;
  }

  // Check roles - TEACHER takes priority over STUDENT if user has both
  if (isTeacher(user.role)) {
    return <>{teacherView}</>;
  }

  if (isStudent(user.role)) {
    return <>{studentView}</>;
  }

  return <>{fallbackView}</>;
};

export default RoleBasedView;
